import { addNamespace } from '@Utils/actions';
import { createAction } from '@reduxjs/toolkit';
import { DeviceStatus } from '@Types';
import {
	GraphDataRecord,
	SensorPeekAsyncResponse,
	SensorTroubleshooting,
} from '@Types/peek';
import { SensorConfigFormShape } from '@Types/configurations.types';

const createActionName = (...p: string[]) => p.join('/');

const ACTION_CONTEXT = 'sensor';
const GET_STATUS = 'getDeviceStatus';
const PEEK = 'peek';
const SENSOR_TROUBLESHOOT = 'sensorTroubleshoot';
const POLL = 'poll';
const ASYNC = 'async';

export const restoreStatusStore = createAction(
	addNamespace(createActionName(ACTION_CONTEXT, 'resetStatusStore')),
);
// * Device status Actions
export const getDeviceStatus = createAction<string>(
	addNamespace(createActionName(ACTION_CONTEXT, GET_STATUS)),
);
export const getDeviceStatusResolved = createAction<DeviceStatus>(
	addNamespace(createActionName(ACTION_CONTEXT, GET_STATUS, 'resolved')),
);
export const getDeviceStatusRejected = createAction(
	addNamespace(createActionName(ACTION_CONTEXT, GET_STATUS, 'rejected')),
);

// ? Test/peek sensor connection
/**
 * @deprecated
 */
export const peekSensorConnection = createAction<SensorTbltParams>(
	createActionName(ACTION_CONTEXT, PEEK),
);
/**
 * @deprecated
 */
export const peekSensorConnectionResolved = createAction<GraphDataRecord[]>(
	createActionName(ACTION_CONTEXT, PEEK, 'resolved'),
);
/**
 * @deprecated
 */
export const peekSensorConnectionRejected = createAction(
	createActionName(ACTION_CONTEXT, PEEK, 'rejected'),
);
/**
 * @deprecated
 */
export const peekSensorReset = createAction(
	createActionName(ACTION_CONTEXT, PEEK, 'reset'),
);
/**
 * @deprecated
 */
export const peekSensorFieldChange = createAction<SensorConfigFormShape>(
	createActionName(ACTION_CONTEXT, PEEK, 'field', 'changed'),
);
/**
 * @deprecated
 */
export const peekSensorComputeQuery = createAction<string>(
	createActionName(ACTION_CONTEXT, PEEK, 'query', 'compute'),
);

// ? Test/peek sensor async
export type PeekSensorActionParams = {
	peekForm: Record<string, string>;
	timeoutMs: number;
	skipTblt?: boolean; // If true, disables troubleshooting on timeout
};
export const peekSensorAsync = createAction<PeekSensorActionParams>(
	createActionName(ACTION_CONTEXT, PEEK, ASYNC),
);
export const peekSensorAsyncResolved = createAction<SensorPeekAsyncResponse>(
	createActionName(ACTION_CONTEXT, PEEK, ASYNC, 'resolved'),
);
export const peekSensorAsyncRejected = createAction(
	createActionName(ACTION_CONTEXT, PEEK, ASYNC, 'rejected'),
);

export type PollPeekSensorActionParams = PeekSensorActionParams & {
	peekResponse: SensorPeekAsyncResponse;
};
export const pollPeekAsyncResults = createAction<PollPeekSensorActionParams>(
	createActionName(ACTION_CONTEXT, POLL, PEEK, 'results'),
);
export const pollPeekAsyncResultsStop = createAction(
	createActionName(ACTION_CONTEXT, POLL, PEEK, 'stop'),
);
export const pollPeekAsyncResultsResolved = createAction<GraphDataRecord[]>(
	createActionName(ACTION_CONTEXT, POLL, PEEK, 'results', 'resolved'),
);
export const pollPeekAsyncResultsRejected = createAction(
	createActionName(ACTION_CONTEXT, POLL, PEEK, 'results', 'rejected'),
);

// ? Test/peek sensor troubleshoot
export type SensorTbltParams = {
	peekForm: Record<string, string>;
	timeoutMs: number;
	skipTblt?: boolean; // If true, disables troubleshooting on timeout
};
export const troubleshootSensor = createAction<SensorTbltParams>(
	createActionName(ACTION_CONTEXT, SENSOR_TROUBLESHOOT),
);
export type ResolvedTbltParams = {
	uuid: string;
	sensorId: string;
	timeoutMs: number;
};
export const troubleshootSensorResolved = createAction<ResolvedTbltParams>(
	createActionName(ACTION_CONTEXT, SENSOR_TROUBLESHOOT, 'resolved'),
);
export const troubleshootSensorRejected = createAction(
	createActionName(ACTION_CONTEXT, SENSOR_TROUBLESHOOT, 'rejected'),
);

export type AsyncPollSensorTbltActionPayload = {
	sensor: string;
	timeoutMs: number;
};
export const pollSensorTroubleshooting =
	createAction<AsyncPollSensorTbltActionPayload>(
		createActionName(ACTION_CONTEXT, POLL),
	);
export const pollSensorTroubleshootingStop = createAction(
	createActionName(ACTION_CONTEXT, POLL, 'stop'),
);
export const pollSensorTroubleshootingResolved = createAction<{
	sensorId: string;
	result: SensorTroubleshooting;
}>(createActionName(ACTION_CONTEXT, POLL, 'resolved'));
export const pollSensorTroubleshootingRejected = createAction(
	createActionName(ACTION_CONTEXT, POLL, 'rejected'),
);

export const pollSensorStateUpdate = createAction<{
	sensorId: string;
	result: SensorTroubleshooting;
}>(createActionName(ACTION_CONTEXT, POLL, 'update'));
